import React from 'react';
import { Container, Heading } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import Header from './Header';
import LearnMoreButton from './LearnMoreButton';

const Mobile: React.FC = () => (
  <Container
    maxW="xl"
    d={{ base: 'flex', desktop: 'none' }}
    flexDir="column"
    px={0}
  >
    <Header mb={500} />
    <Heading size={300} isLight as="h3">
      Easy imports
    </Heading>
    <Heading size={200} isDisplay marginBottom={700} as="p">
      Import 3D model data and accurate measurements directly into your claims
      management tool of choice. No manual sketching required.
    </Heading>
    <StaticImage
      placeholder="blurred"
      alt="insurance easy import"
      src="../../../assets/images/insurance_easy_import.png"
    />
    <Heading size={300} isLight mt="72px" as="h3">
      Better estimates
    </Heading>
    <Heading size={200} isDisplay marginBottom={700} as="p">
      Better measurements means more accurate estimations. Minimize errors and
      settle property claims quickly and more accurately.
    </Heading>
    <Heading size={200} isDisplay marginBottom={700} as="p">
      Pass your property measurements right into Xactimate or connect directly
      with Symbility or Filetrac.
    </Heading>
    <StaticImage
      placeholder="blurred"
      alt="fast estimation"
      src="../../../assets/images/insurance_fast_estimation.png"
    />
    <LearnMoreButton />
  </Container>
);

export default Mobile;
